import { render, staticRenderFns } from "./DeminimisBenefitsDetails.vue?vue&type=template&id=252a7139&scoped=true"
import script from "./DeminimisBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./DeminimisBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./DeminimisBenefitsDetails.vue?vue&type=style&index=0&id=252a7139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a7139",
  null
  
)

export default component.exports